export default function toggleDrawer(open) {
  return { type: 'TOGGLE_DRAWER', payload: { open } };
}
